<template>
  <b-container>
    <Faq :custom-faq="customFaq" :title="title" :prismic-props="prismicProps" />
  </b-container>
</template>

<script>
import Faq from '@/components/Common/Faq';
export default {
  components: {
    Faq
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      customFaq: [],
      prismicProps: {},
      title: ''
    };
  },
  created() {
    const { primary, items: faqs, slice_label } = this.slice;
    this.title = this.slice.primary.title1[0]?.text ? this.slice.primary.title1 : [];

    this.prismicProps = {
      underline: primary.underline,
      border_bottom: primary.border_bottom,
      textColor: primary.text_color ? primary.text_color : '#707070',
      itemImage: primary.item_image?.url ? primary.item_image?.url : '',
      twoColumns: primary.two_columns,
      alternativeLayout: slice_label === 'layout_2',
      subtitle: this.slice.primary.subtitle[0]?.text ? this.slice.primary.subtitle : undefined
    };

    this.customFaq = faqs
      .filter((el) => el.question[0]?.text && el.answer[0]?.text)
      .map((el) => {
        return {
          ...el,
          question: el.question[0]?.text,
          answer: el.answer
        };
      });
  }
};
</script>

<style lang="scss" scoped></style>
